import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import {
    getCustomerConversionResaleById
} from '@/api/customer'
import { menuBtn } from '@/utils/menu_level2_button'

@Component({})
export default class ResaleCustomerInfo extends Vue {
    culesInfoShow = false
    customerInfoShow = true
    operationShow = true
    id: number;
    infoData: any = ''
    // 跟进记录
    tableData = []
    page = 1
    limit = 20
    total = 0
    loading = false
    isReceive: any = ''
    informationListImg: any = []
    menuBtn = menuBtn
    activities = []
    sourceType = ''

    // created()
    created() {
        const query = this.$route.query
        this.id = Number(query.id)
        this.getCustomerConversionResaleById()
    }

    // methods
    formatDate = formatDate

    async getCustomerConversionResaleById() {
        this.loading = true
        await getCustomerConversionResaleById({id: String(this.id)}).then((data:any)=>{
            this.infoData = JSON.parse(JSON.stringify(data.customerConversion))
            //    审批流程
            this.activities = data.customerConversion.messageReviewList
            const list = []
            const list1 = this.infoData.informationList
            this.sourceType =  this.infoData?this.infoData.marketClue.sourceType:''
            list1.forEach((item)=>{
                if(item) {
                    const url = decodeURI(item)
                    const str = url.split('/crm/')[1];
                    if(str) {
                        const name = str.slice(20);
                        const obj = {name: name, url: item}
                        list.push(obj)
                    }
                    if(this.fileExtension(item)==='png'|| this.fileExtension(item.url)=='PNG'|| this.fileExtension(item.url)=='JPG' || this.fileExtension(item)==='jpg' || this.fileExtension(item.url)=='JPEG'|| this.fileExtension(item)==='jpeg'){
                        this.informationListImg.push(item)
                    }
                }
            })
            this.infoData.informationList = list
            this.tableData = this.infoData.customerConversionFollowList
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }


}
